<template>
  <div v-loading="loading">
    <div class="title">我的出题</div>
    <div style="font-size:14px;color:#E6A23C" v-if="base_info.reject_count">
      <el-button type="text" style="color:#E6A23C;" @click="handleClick">
        您当前有{{
          base_info.reject_count
        }}个题目审核未通过，请及时修改，点击查看题目</el-button
      >
    </div>
    <div class="mb-12">
      <select-skill-stack
        size="medium"
        class="w-120 mr-12"
        :value.sync="stack"
        @change="handleChangeSkillStack"
      ></select-skill-stack>
      <el-select
        class="w-120 mb-12 mr-12"
        v-model="status"
        size="medium"
        placeholder="状态"
        clearable
        @change="search"
      >
        <el-option label="已提交待审核" :value="1"></el-option>
        <el-option label="审核通过待质检" :value="6"></el-option>
        <el-option label="通过入库" :value="2"></el-option>
        <el-option label="质检不通过" :value="3"></el-option>
        <el-option label="审核不通过" :value="7"></el-option>
        <el-option label="需优化" :value="8"></el-option>
        <el-option label="废弃" :value="4"></el-option>
        <el-option label="终审驳回" :value="11"></el-option>
      </el-select>
      <el-input
        class="w-150 mb-12 mr-12"
        placeholder="题干"
        prefix-icon="el-icon-search"
        v-model.trim="stem"
        size="medium"
        clearable
        @change="search"
      >
      </el-input>
      <el-select
        class="w-120 mr-12"
        v-model="level"
        clearable
        @change="search"
        placeholder="难度等级"
        size="medium"
      >
        <el-option label="简单" :value="1"></el-option>
        <el-option label="普通" :value="2"></el-option>
        <el-option label="困难" :value="3"></el-option>
      </el-select>
      <el-select
        class="w-120 mr-12"
        v-model="question_type"
        clearable
        @change="search"
        placeholder="题目类别"
        size="medium"
      >
        <el-option label="场景" :value="4"></el-option>
        <el-option label="概念" :value="2"></el-option>
        <el-option label="代码" :value="3"></el-option>
        <el-option label="其他" :value="1"></el-option>
      </el-select>
      <el-cascader
        v-model="common_industry_id"
        :options="industryList"
        :props="optionProps"
        placeholder="请选择行业分类"
        size="medium"
        class="w-132 mr-12"
        @change="search"
        clearable
      ></el-cascader>
      <el-button type="primary" size="medium" plain @click="search"
        >查询</el-button
      >
      <el-button size="medium" @click="clearSearch">重置</el-button>
      <zhu-button
        v-if="
          authPermissions.includes(
            'question.api.fuwu_admin.skill_question_tasks.index'
          )
        "
        class="float-btn"
        text="去出题"
        :shadow="true"
        size="medium"
        type="primary"
        @click="goAssignTopic"
      >
      </zhu-button>
    </div>
    <el-table :data="list" :stripe="true">
      <el-table-column width="80" label="编号" prop="id"></el-table-column>
      <el-table-column
        width="150"
        label="关联技能栈"
        prop="stack.name"
      ></el-table-column>
      <el-table-column label="题干">
        <template slot-scope="scope">
          <div class="hidden-redundant">
            {{ scope.row.stem }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        width="110"
        label="任务优先级"
        prop="required_total_number"
      >
        <template slot="header">
          <div>
            任务优先级<el-tooltip>
              <div slot="content">
                代表任务的紧急程度P1（非常紧急）～P10（不紧急）
              </div>
              <i class="el-icon-question" style="margin-left: 5px"></i>
            </el-tooltip>
          </div>
        </template>
        <template slot-scope="scope">
          <div>P{{ scope.row.priority }}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="题目类别"
        prop="question_type_label"
      ></el-table-column>
      <el-table-column width="80" label="难度等级">
        <template slot-scope="scope">
          <span v-if="scope.row.level === 1">简单</span>
          <span v-if="scope.row.level === 2">普通</span>
          <span v-if="scope.row.level === 3">困难</span>
        </template>
      </el-table-column>
      <el-table-column width="100" v-if="false">
        <template slot="header">
          <div @click="toggleShowContent" class="toggle-show">
            <span>题目单价</span>
            <i class="el-icon-view toggle-show-icon"></i>
          </div>
        </template>
        <template slot-scope="scope">
          <show-hide-content
            :value="scope.row.unit_price"
            :show.sync="isShow"
          ></show-hide-content>
        </template>
      </el-table-column>
      <el-table-column label="关联行业" width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          {{
            (scope.row.common_industries || []).length
              ? String(
                  scope.row.common_industries.map(data => {
                    return data.name;
                  })
                )
              : "-"
          }}
        </template>
      </el-table-column>
      <el-table-column width="180" label="提交时间">
        <template slot-scope="scope">
          <i class="el-icon-time"></i>
          <span style="margin-left: 10px">{{ scope.row.created_at }}</span>
        </template>
      </el-table-column>
      <el-table-column width="120" label="状态" prop="status_label">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 1" type="warning" size="medium"
            >已提交待审核</el-tag
          >
          <el-tag v-if="scope.row.status === 2" size="medium">通过入库</el-tag>
          <el-tag v-if="scope.row.status === 3" type="danger" size="medium"
            >质检不通过</el-tag
          >
          <el-tag v-if="scope.row.status === 4" type="danger" size="medium"
            >题目下架</el-tag
          >
          <el-tag v-if="scope.row.status === 6" size="medium"
            >审核通过待质检</el-tag
          >
          <el-tag v-if="scope.row.status === 7" type="danger" size="medium"
            >审核不通过</el-tag
          >
          <el-tag v-if="scope.row.status === 9" size="medium"
            >质检通过待终审</el-tag
          >
          <el-tag v-if="scope.row.status === 10" type="danger" size="medium"
            >题目作废</el-tag
          >
          <el-tag v-if="scope.row.status === 11" type="danger" size="medium"
            >终审驳回</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        v-if="
          authPermissions.includes(
            'question.api.fuwu_admin.skill_questions.show'
          )
        "
        width="55"
        fixed="right"
        label="操作"
      >
        <template slot-scope="scope">
          <el-link
            type="primary"
            :underline="false"
            @click="handleDetail(scope.row.id)"
            >详情</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, prev, pager, next, jumper"
      @current-change="goPage"
      :current-page.sync="pagination.currentPage"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      :hide-on-single-page="true"
    >
    </el-pagination>
  </div>
</template>

<script>
import { mapState } from "vuex";
import skillService from "@/global/service/skill";
import kcellService from "@/global/service/kcell";
import ShowHideContent from "@/components/ShowHideContent";
import SelectSkillStack from "@/components/SelectSkillStack.vue";
export default {
  components: {
    ShowHideContent,
    SelectSkillStack
  },
  data() {
    return {
      loading: true,
      status: null,
      isShow: false,
      stem: "",
      stack: null,
      level: null,
      list: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      chooseSkillStack: null,
      question_type: null,
      base_info: {},
      targetStatus: null,
      common_industry_id: null,
      industryList: [],
      optionProps: {
        value: "id",
        label: "name",
        children: "children",
        emitPath: false
      }
    };
  },
  computed: {
    ...mapState(["authPermissions"])
  },
  created() {
    this.getData();
    this.getConst();
  },
  watch: {
    $route() {
      this.getData();
      this.getConst();
    }
  },
  methods: {
    getConst() {
      kcellService.kcellIndustry().then(res => {
        this.industryList = res;
      });
    },
    getData() {
      const page = Number(this.$route.query.page) || 1;
      const params = {
        page,
        page_size: this.pagination.pageSize,
        status: this.status ? this.status : this.targetStatus,
        level: this.level,
        stem: this.stem,
        stack_id: this.stack,
        question_type: this.question_type,
        common_industry_id: this.common_industry_id
      };
      this.loading = true;
      skillService
        .topicList(params)
        .then(res => {
          this.list = res.list;
          this.base_info = res.base_info;
          this.pagination.currentPage = Number(res.pagination.current_page);
          this.pagination.total = Number(res.pagination.total);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    goAssignTopic() {
      this.$router.push({ name: "QuestionSkillTaskSelf" });
    },
    goDetail(id) {
      this.$router.push({
        name: "QuestionSkillMyDetail",
        params: { id }
      });
    },
    goPage(val) {
      this.$router.push({
        name: "QuestionSkillMySelf",
        query: { page: val }
      });
    },
    toggleShowContent() {
      this.isShow = !this.isShow;
    },
    search() {
      if (JSON.stringify(this.$route.query) !== "{}") {
        this.$router.push({
          name: "QuestionSkillMySelf",
          query: {}
        });
      }
      this.getData();
    },
    clearSearch() {
      this.status = null;
      this.stem = "";
      this.level = null;
      this.question_type = null;
      this.targetStatus = null;
      this.common_industry_id = null;
      if (JSON.stringify(this.$route.query) !== "{}") {
        this.$router.push({
          name: "QuestionSkillMySelf",
          query: {}
        });
      }
      this.getData();
    },
    handleChangeSkillStack(e) {
      this.chooseSkillStack = e;
    },
    handleClick() {
      this.targetStatus = -1;
      this.status = null;
      this.getData();
    },
    handleDetail(id) {
      let url = this.$router.resolve({
        name: "QuestionSkillMyDetail",
        params: { id }
      });
      window.open(url.href);
    }
  }
};
</script>

<style lang="less" scoped>
.float-btn {
  z-index: 10;
  float: right;
}
.hidden-redundant {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.toggle-show {
  cursor: pointer;
  .toggle-show-icon {
    margin-left: 4px;
  }
  &:hover {
    color: #409eff;
  }
}
.link {
  color: #409eff;
}
</style>
